/**
 * Password rules for registration and password changes.
 * Keep in sync with spud_utils/passwords.py.
 */

export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_RULES = [
    {
        id: 'length',
        label: 'At least 8 characters',
        test: (password) => password.length >= PASSWORD_MIN_LENGTH,
    },
    {
        id: 'lower',
        label: 'One lowercase letter',
        test: (password) => /[a-z]/.test(password),
    },
    {
        id: 'upper',
        label: 'One uppercase letter',
        test: (password) => /[A-Z]/.test(password),
    },
    {
        id: 'digit',
        label: 'One number',
        test: (password) => /\d/.test(password),
    },
    {
        id: 'symbol',
        label: 'One symbol',
        test: (password) => /[^A-Za-z0-9]/.test(password),
    },
];

export function unmetPasswordRules(password) {
    const value = typeof password === 'string' ? password : '';
    return PASSWORD_RULES.filter((rule) => !rule.test(value)).map((rule) => rule.label);
}

export function passwordError(password) {
    const unmet = unmetPasswordRules(password);
    if (unmet.length === 0) return '';
    return `Password must include: ${unmet.join(', ')}.`;
}
